<template>
  <div class="row">
    <button class="btn btn-danger" @click="clearCards()">Reset Cards</button>
    <h3 class="col-md-12 northern-title">Neutral {{ this.neutral.length }}</h3>
    <br />
    <div
      class="card-container"
      v-bind:key="card.name"
      v-for="card in this.neutral"
    >
      <div>
        <img
          v-if="!card.collected"
          class="card"
          :src="require(`@/assets/cards/${card.faction}/${card.img}.png`)"
        />
      </div>
      <div v-if="!card.collected" class="imgButton">
        <button class="btn btn-primary" @click="collectCard(card)">
          Collect card
        </button>
      </div>
    </div>

    <br />
    <div class="row">
      <span>
        <img class="faction-logo" :src="require(`@/assets/northern.png`)" />
        <h3 class="col-md-12 northern-title">
          Northern Realms {{ this.northern.length }}
        </h3>
      </span>
    </div>
    <div
      class="card-container"
      v-bind:key="card.name"
      v-for="card in this.northern"
    >
      <div>
        <img
          v-if="!card.collected"
          class="card"
          :src="require(`@/assets/cards/${card.faction}/${card.img}.png`)"
        />
      </div>
      <div v-if="!card.collected" class="imgButton">
        <button class="btn btn-primary" @click="collectCard(card)">
          Collect card
        </button>
      </div>
    </div>

    <div class="row">
      <span>
        <img class="faction-logo" :src="require(`@/assets/nilfgaardian.png`)" />
        <h3 class="col-md-12 nilfgaard-title">
          Nilfgaardian {{ this.nilfgaardian.length }}
        </h3>
      </span>
    </div>
    <div
      class="card-container"
      v-bind:key="card.name"
      v-for="card in this.nilfgaardian"
    >
      <div>
        <img
          v-if="!card.collected"
          class="card"
          :src="require(`@/assets/cards/${card.faction}/${card.img}.png`)"
        />
      </div>
      <div v-if="!card.collected" class="imgButton">
        <button class="btn btn-primary" @click="collectCard(card)">
          Collect card
        </button>
      </div>
    </div>
    <br />

    <div class="row">
      <span>
        <img class="faction-logo" :src="require(`@/assets/monsters.png`)" />
        <h3 class="col-md-12 monster-title">
          Monster {{ this.monster.length }}
        </h3>
      </span>
    </div>

    <div
      class="card-container"
      v-bind:key="card.name"
      v-for="card in this.monster"
    >
      <div>
        <img
          v-if="!card.collected"
          class="card"
          :src="require(`@/assets/cards/${card.faction}/${card.img}.png`)"
        />
      </div>
      <div v-if="!card.collected" class="imgButton">
        <button class="btn btn-primary" @click="collectCard(card)">
          Collect card
        </button>
      </div>
    </div>
    <div class="row">
      <span>
        <img class="faction-logo" :src="require(`@/assets/scoia.png`)" />
        <h3 class="col-md-12 scoa-title">
          Scoiatael {{ this.scoiatael.length }}
        </h3>
      </span>
    </div>
    <div
      class="card-container"
      v-bind:key="card.name"
      v-for="card in this.scoiatael"
    >
      <div>
        <img
          v-if="!card.collected"
          class="card"
          :src="require(`@/assets/cards/${card.faction}/${card.img}.png`)"
        />
      </div>
      <div v-if="!card.collected" class="imgButton">
        <button class="btn btn-primary" @click="collectCard(card)">
          Collect card
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as cards from "../utils/cards.js";
var _ = require("lodash");

export default {
  name: "HelloWorld",
  data() {
    return {
      allCards: cards,
    };
  },
  mounted() {
    console.log("App mounted!");
    if (localStorage.getItem("cards"))
      this.allCards = JSON.parse(localStorage.getItem("cards"));
  },
  computed: {
    neutral() {
      var neutral = _.filter(this.allCards, {
        faction: "neutral",
      });

      return _.orderBy(neutral, "name");
    },
    northern() {
      var northern = _.filter(this.allCards, {
        faction: "northern",
      });

      return _.orderBy(northern, "name");
    },
    nilfgaardian() {
      var nilf = _.filter(this.allCards, {
        faction: "nilfgaardian",
      });

      return _.orderBy(nilf, "name");
    },
    monster() {
      var monster = _.filter(this.allCards, {
        faction: "monster",
      });

      return _.orderBy(monster, "name");
    },
    scoiatael() {
      var scoia = _.filter(this.allCards, {
        faction: "scoiatael",
      });

      return _.orderBy(scoia, "name");
    },
  },
  methods: {
    collectCard(card) {
      card.collected = !card.collected;
      localStorage.setItem("cards", JSON.stringify(this.allCards));
    },
    clearCards() {
      localStorage.clear();
      this.allCards = cards;
    },
  },
};
</script>

<style scoped>
.imgButton {
  text-align: center;
}
.row {
  width: 100%;
  height: 100%;
  margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.card {
  max-height: 300px;
  margin: 15px;
  border-radius: 12px;
}

.northern-title {
  color: #006ae9;
}
.nilfgaard-title {
  color: #f1cf04;
}
.monster-title {
  color: #bf0121;
}
.scoa-title {
  color: #2e9005;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue